export default products => {
  if (Array.isArray(products) && products.length) {
    const baseProduct = products.find(product => product.Type === 'DealProduct')
    return baseProduct ? true : false
  }
  return true
}
